<template>
  <v-form>
    <v-row align="center" justify="center">
      <h3><b>{{$t('json.exportsettings')}}</b></h3>
    </v-row>
    <v-row align="center" justify="center">
      <v-col cols="12"><v-text-field :disabled="disable || preview" @change="onChange" v-model="ExportSettings.ExportFolder" :label="$t('json.export_folder')"></v-text-field></v-col>
      <v-col cols="12"><v-select :disabled="disabled || preview" @change="onChange" :items="formats" v-model="ExportSettings.Format" :label="$t('json.export_format')"></v-select></v-col>
      <v-col cols="12"><v-text-field :disabled="disabled || preview" @change="onChange" v-model="ExportSettings.Quality" :label="$t('json.export_quality')" type="number"></v-text-field></v-col>
      <v-col cols="12"><v-select :disabled="disabled || preview" @change="changeDepth" :items="depths" v-model="ExportSettings.Depth" :label="$t('json.export_color')"></v-select></v-col>
      <v-col cols="12"><v-select :disabled="disabled || preview" @change="onChange" :items="compressions" :label="$t('json.export_compress')" v-model="ExportSettings.Compression"></v-select></v-col>
      <v-col cols="12"><v-switch :disabled="disable || preview" @change="onChange" :label="$t('json.export_skip')" v-model="ExportSettings.Skip"></v-switch></v-col>
      <!-- CreateNewBatchDialog: true, // show create batch dialog if CreateBatchAuto=false
                    CreateNewBatchAuto: false -->
      <v-col cols="12"><v-switch :disabled="disable || preview" @change="onChangeNewBatchDialog" :label="'Show Create New Batch Dialog'" v-model="ExportSettings.CreateNewBatchDialog"></v-switch></v-col>
      <v-col cols="12"><v-switch :disabled="disable || preview" @change="onChangeNewBatchAuto" :label="'Create new batch automatically after export'" v-model="ExportSettings.CreateNewBatchAuto"></v-switch></v-col>
    </v-row>
  </v-form>
</template>

<script>

export default {
  name: 'ExportSettings',
  props: {
    props: {
      type: Object,
      default: null
    },
    disable: {
      type: Boolean,
      default: false
    },
    preview: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      // formats: ['TIF', 'JPG', 'BMP', 'PNG', 'PDF'],
      formats: ['PDF'],
      depths: ['Color', 'BlackWhite', 'GrayScale'],
      compressions: [],
      /* allCompressions: ['Group4', 'LZW', 'ZIP', 'JPG', 'MRC', 'NoCompression'],
      colorCompressions: ['JPG', 'MRC', 'NoCompression'],
      grayCompressions: ['JPG', 'NoCompression'],
      bwCompressions: ['Group4', 'LZW', 'ZIP', 'NoCompression'] */
      allCompressions: ['Group4', 'LZW', 'NoCompression'],
      colorCompressions: ['LZW', 'NoCompression'],
      grayCompressions: ['LZW', 'NoCompression'],
      bwCompressions: ['Group4', 'NoCompression']
    }
  },
  computed: {
    ExportSettings () {
      return this.props.ExportSettings
    },
    disabled () {
      if (this.disable || this.ExportSettings.Skip) return true
      return false
    }
  },
  methods: {
    changeDepth (val) {
      console.log('CHNAGE DEPTH', val)
      if (val === 'Color') {
        this.compressions = this.colorCompressions
        if (!this.compressions.includes(this.ExportSettings.Compression)) {
          this.ExportSettings.Compression = 'LZW'
        }
      }
      if (val === 'GrayScale') {
        this.compressions = this.grayCompressions
        if (!this.compressions.includes(this.Compression)) {
          this.ExportSettings.Compression = 'LZW'
        }
      }
      if (val === 'BlackWhite') {
        this.compressions = this.bwCompressions
        if (!this.compressions.includes(this.ExportSettings.Compression)) {
          this.ExportSettings.Compression = 'Group4'
        }
      }
      console.log(this.ExportSettings.Depth, this.ExportSettings.Compression)
      this.onChange(null)
    },
    onChange (val) {
      console.log('CHNAGE EXPORT SETTINGS', val, this.ExportSettings.CreateNewBatchDialog, this.ExportSettings.CreateNewBatchAuto)
      this.$emit('changeSettings')
    },
    onChangeNewBatchDialog (val) {
      if (this.ExportSettings.CreateNewBatchDialog) {
        this.ExportSettings.CreateNewBatchAuto = false
      }
      this.$emit('changeSettings')
    },
    onChangeNewBatchAuto (val) {
      if (this.ExportSettings.CreateNewBatchAuto) {
        this.ExportSettings.CreateNewBatchDialog = false
      }
      this.$emit('changeSettings')
    }
  },
  watch: {
    'props.Depth': function (val) {
      console.log('props.Depth changes', val)
      this.changeDepth(val)
      /* if (val.toUpperCase() === 'BLACKWHITE' && this.props.Compression === 'MRC') {
        this.props.Compression = 'Group4'
      }
      if (val.toUpperCase() === 'COLOR' && this.props.Compression !== 'MRC') {
        this.props.Compression = 'MRC'
      } */
    }
  },
  created () {
    this.changeDepth(this.ExportSettings.Depth)
  }
}
</script>
